import React from "react";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa6";
import "./FooterPage.css";
import UgLogo from "../../Assets/images/logo.png";

const FooterPage = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="alumni-footer">
      <div className="alumni-footer-content">

        {/* Brand */}
        <div className="footer-brand">
          <img
            src={UgLogo}
            alt="UGAAL_LOGO"
            className="footer-logo"
          />
          <p className="footer-tagline">
            Connecting graduates of the University of Ghana living in Liberia.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <a href="/">Home</a>
          <a href="/membership">Become aMember</a>
          <a href="/projects">Projects & Initiatives</a>
          <a href="/jobs&internship">Jobs & Internships</a>
          <a href="/alumni-talent-pool">Alumni Talent Pool</a>
          <a href="/contact-us">Contact Us</a>
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <p>Email: info@ugaaliberia.org </p>
          <p>Phone: +231 881 924 553</p>
          <p>Mon – Fri | 8:00 AM – 5:00 PM</p>
        </div>

        {/* Social */}
        <div className="footer-social">
          <h4>Connect With Us</h4>
          <div className="social-icons">
            
           <a
              href="https://www.facebook.com/profile.php?id=61583738435863"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.linkedin.com/company/ugaa-liberia"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
            
          
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>
          © {year} University of Ghana Alumni Association Liberia. All Rights Reserved.
        </p>
        <p className="developer-credit">
          Powered by: techbyodumgya@gmail.com
        </p>
      </div>
    </footer>
  );
};

export default FooterPage;
